module.exports = __webpack_public_path__ + "static/media/KPMG.e3f128cf.svg";